// utils/passwordRules.ts
//
// The one list of password rules. The register and reset-password forms show it as a checklist
// and validate with isValidPassword, so a password can never tick every box and still fail
// (the checklist used to omit the lowercase rule the schema required).

export type PasswordRule = {
  label: string;
  test: (password: string) => boolean;
};

const PERSIAN_ARABIC_LETTERS = /[؀-ۿ]/;

export const PASSWORD_RULES: PasswordRule[] = [
  {
    label: 'رمز عبور باید حداقل ۸ کاراکتر باشد.',
    test: (password) => password.length >= 8
  },
  {
    label: 'رمز عبور باید شامل حروف انگلیسی و عدد باشد.',
    test: (password) =>
      /[A-Za-z]/.test(password) &&
      /\d/.test(password) &&
      !PERSIAN_ARABIC_LETTERS.test(password)
  },
  {
    label: 'رمز عبور باید حداقل یک حرف کوچک داشته باشد.',
    test: (password) => /[a-z]/.test(password)
  },
  {
    label: 'رمز عبور باید حداقل یک حرف بزرگ داشته باشد.',
    test: (password) => /[A-Z]/.test(password)
  }
];

const MAX_PASSWORD_LENGTH = 180;

export const isValidPassword = (password: string): boolean =>
  password.length <= MAX_PASSWORD_LENGTH &&
  PASSWORD_RULES.every((rule) => rule.test(password));
